import React from 'react';
import T from 'prop-types';
import { HomeOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';

const DeleteAccountSuccessModal = ({ cancelReload, isVisible }) => {
  const handleClick = () => {
    cancelReload();
    window.location.reload(true);
  };

  const footer = (
    <Button icon={<HomeOutlined />} onClick={handleClick} type="primary">
      Go to Homepage
    </Button>
  );

  return (
    <Modal bordered={false} closable={false} footer={footer} title="Account deleted" visible={isVisible}>
      You will be redirected to Homepage in a few seconds. Alternatively press the button below.
    </Modal>
  );
};

DeleteAccountSuccessModal.propTypes = {
  cancelReload: T.func.isRequired,

  isVisible: T.bool.isRequired,
};

export default DeleteAccountSuccessModal;
